function setCookie(name, value, days = 7) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${encodeURIComponent(JSON.stringify(value))}; ${expires}; path=/; SameSite=Strict`;
}

function getCookie(name) {
    const cookieName = `${name}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
    
    for(let i = 0; i < cookieArray.length; i++) {
        let cookie = cookieArray[i];
        while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(cookieName) === 0) {
            try {
                return JSON.parse(cookie.substring(cookieName.length, cookie.length));
            } catch(e) {
                return null;
            }
        }
    }
    return null;
}

function removeCookie(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}
// Add this helper function at the top of your file
function safeRemoveEventListener(element, event, handler) {
  if (element) {
    element.removeEventListener(event, handler);
  }
}

function validateFileInput(fileInput) {
  // Check if files array exists and has items
  if (!fileInput.files || fileInput.files.length === 0) {
    return false;
  }
  
  const file = fileInput.files[0];
  
  // Check if it's a real file object with proper properties
  if (!file || !file.type || !file.size) {
    return false;
  }
  
  // Check if file type is an image
  if (!file.type.match('image.*')) {
    return false;
  }
  
  // Validate file size (max 10MB)
  if (file.size > 10 * 1024 * 1024) {
    return false;
  }
  
  return true;
}
function safeRemoveEventListener(element, event, handler) {
  if (element) {
    element.removeEventListener(event, handler);
  }
}
// PDP Personalization Form Component
document.addEventListener("DOMContentLoaded", ()=>{

    if(!localStorage.getItem('formData')) {
        localStorage.removeItem('bundleBody');
    }

    const tabs = document.querySelectorAll("[id^=tab-]");
    const forms = {
        "tab-name": document.getElementById("form-primary"),
        "tab-icon": document.getElementById("form-secondary"),
        "tab-both": document.getElementById("form-tertiary"),
    };

    forms["tab-name"].classList.remove("tw-hidden");
    document.getElementById("tab-name").classList.remove("color_E6E6E6");
    document.getElementById("tab-name").classList.add("color_C8C8CA");

    tabs.forEach((tab) => {
        tab.addEventListener("click", (e)=>{
            Object.values(forms).forEach(form => form.classList.add("tw-hidden"));

            forms[tab.id].classList.remove("tw-hidden");
            forms[tab.id].classList.add("tw-transition-opacity", "tw-duration-300", "tw-opacity-0");
            forms[tab.id].offsetHeight; 
            forms[tab.id].classList.remove("tw-opacity-0");
            forms[tab.id].classList.add("tw-opacity-100");

            if (forms[tab.id].id === 'form-secondary') {
                const rangePrice = document.getElementById('secondary-form-price');
                rangePrice.textContent = rangePrice.dataset.formPrice;
            }

            if (forms[tab.id].id === 'form-tertiary') {
                const rangePrice = document.getElementById('tertiary-form-price');
                rangePrice.textContent = rangePrice.dataset.formPrice;
            }
            

            tabs.forEach(tab => tab.classList.remove("color_C8C8CA"));
            tabs.forEach(tab => tab.classList.add("color_E6E6E6"));

            // Add the active class to the clicked tab
            tab.classList.add("color_C8C8CA");
            tab.classList.remove("color_E6E6E6");
        })
    })

    const primaryName = document.querySelector('.primary_name');
    const tertiaryName = document.querySelector('.tertiary_name');

    if(primaryName){
        primaryName.addEventListener('blur', () => {
            console.log("Inside Event");
            
            if(primaryName.value == ''){
                document.querySelector('#primary-error-message').classList.remove('tw-hidden');
            }
            else{
                document.querySelector('#primary-error-message').classList.add('tw-hidden');
            }
        })
    }

    if(tertiaryName){
        tertiaryName.addEventListener('blur', () => {
            if(tertiaryName.value == ''){
                document.querySelector('#tertiary-error-message').classList.remove('tw-hidden');
            }
            else{
                document.querySelector('#tertiary-error-message').classList.add('tw-hidden');
            }
        })
    }

});


function attachEventListeners() {
    const fileInput = document.getElementById('property-custom-icon');
    const fileInputLabel = document.getElementById('upload-label');
    const fileDisclaimer = document.getElementById('file-disclaimer');
    const labelAbbr = document.getElementById('label-abbr');
    let dataValue = fileInputLabel.dataset.labelValue;
    if( fileInput ) {
        fileInput.addEventListener('change', () => {
            
           if(fileInput.files.length > 0) {
                let fileName = fileInput.files[0].name;
                labelAbbr.title = fileName;
                fileInputLabel.textContent = fileName;
                fileDisclaimer.textContent = 'File Uploaded Successfully';
                fileDisclaimer.style.fontWeight = 'bold';
           }
           else{
            fileInputLabel.textContent = dataValue;
            fileDisclaimer.textContent = 'Only Accepting files lesser than 10MB';
           }
        })
    }
}

class PersonalizeButton extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback(){
        this.addEventListener('click', this.openModel.bind(this));
        if(document.getElementById('close-model')){
            document.getElementById('close-model').addEventListener('click', this.closeModel.bind(this));
        }
        if(document.getElementById('edit-model-open')){
            document.getElementById('edit-model-open').addEventListener('click', this.openModel.bind(this));
        }
    }

    openModel() {
        document.querySelector("#dialog-backdrop").classList.remove("pointer-events-none","opacity-0");
        document.querySelector("#data-dialog").classList.remove("opacity-0", "-translate-y-14");
        document.querySelector("#data-dialog").classList.add("opacity-1", "translate-y-0");
        document.body.classList.add('tw-overflow-hidden');
    }
    closeModel(){
        document.querySelector("#dialog-backdrop").classList.add("pointer-events-none","opacity-0");
        document.querySelector("#data-dialog").classList.remove("opacity-1", "translate-y-0");
        document.querySelector("#data-dialog").classList.add("opacity-0", "-translate-y-14");
        document.body.classList.remove('tw-overflow-hidden');
        document.body.classList.add('tw-overflow-none');
    }
}

customElements.define('personalize-button', PersonalizeButton);

class ColorPicker extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const colorInputs = this.querySelectorAll('.color-input');
        const colorLabels = this.querySelectorAll('.color-label');
        const selectedColorSpan = this.querySelector('#selected-color');

        // Don't automatically set the initial color
        selectedColorSpan.textContent = ''; // Empty by default

        colorInputs.forEach((input, index) => {
            input.addEventListener('change', () => {
                selectedColorSpan.textContent = input.value;
                // Hide error message when color is selected
                const colorError = document.querySelector("#primary-color-error");
                if (colorError) {
                    colorError.classList.add('tw-hidden');
                }
                // Remove the styles from all labels
                colorLabels.forEach(label => {
                    label.style.border = 0;
                    label.style.padding = 0;
                    label.style.width = '3.2rem';
                    label.style.height = '1.6rem';
                    label.style.outline = 'none';
                });
                // Add Styles to the selected label
                colorLabels[index].style.border = '0.1rem solid #f8f6f3';
                colorLabels[index].style.outline = 'solid';
                colorLabels[index].style.outlineWidth = '0.2rem';
                colorLabels[index].style.outlineColor = '#808080';
            });
        });
    }
}

customElements.define('color-picker', ColorPicker);

class TertiaryColorPicker extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const colorInputs = this.querySelectorAll('.tertiary-color-input');
        const colorLabels = this.querySelectorAll('.tertiary-color-label');
        const selectedColorSpan = this.querySelector('#selected-color');

        // Don't automatically set the initial color
        selectedColorSpan.textContent = ''; // Empty by default

        colorInputs.forEach((input, index) => {
            input.addEventListener('change', () => {
                selectedColorSpan.textContent = input.value;
                // Hide error message when color is selected
                const colorError = document.querySelector("#tertiary-color-error");
                if (colorError) {
                    colorError.classList.add('tw-hidden');
                }
                // Remove the styles from all labels
                colorLabels.forEach(label => {
                    label.style.border = 0;
                    label.style.padding = 0;
                    label.style.width = '3.2rem';
                    label.style.height = '1.6rem';
                    label.style.outline = 'none';
                });
                // Add Styles to the selected label
                colorLabels[index].style.border = '0.1rem solid #f8f6f3';
                colorLabels[index].style.width = '3.2rem';
                colorLabels[index].style.height = '1.6rem';
                colorLabels[index].style.outline = 'solid';
                colorLabels[index].style.outlineWidth = '0.2rem';
                colorLabels[index].style.outlineColor = '#808080';
            });
        });
    }
}

customElements.define('tertiary-color-picker', TertiaryColorPicker);

class IconPicker extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const iconInputs = this.querySelectorAll('.icon-input');
        const iconLabels = this.querySelectorAll('.icon-label');
        const selectedIconSpan = this.querySelector('#selected-icon');

        // Initialize the selected icon and border on page load
        initialRadioCheckForIcon(this, selectedIconSpan);

        iconInputs.forEach((input, index) => {
            input.addEventListener('change', (e) => {
                updatePrice(e, 'secondary');
                
                // Hide icon error when an icon is selected
                const iconError = document.querySelector("#secondary-icon-error");
                if (iconError) {
                    iconError.classList.add('tw-hidden');
                }
                
                const formData = JSON.parse(localStorage.getItem('formData') || '{}');
                if (formData) {
                    formData.customIcon = '';
                    localStorage.setItem('formData', JSON.stringify(formData));
                    document.getElementById('property-custom-icon').value = '';
                }
                selectedIconSpan.textContent = input.value;
                // Remove the styles from all labels
                iconLabels.forEach(label => {
                    label.style.border = '0';
                    label.style.padding = 0;
                    label.style.width = '3.6rem';
                    label.style.height = '3.6rem';
                });
                // Add Styles to the selected label
                iconLabels[index].style.border = '0.1rem solid #292C35';
                iconLabels[index].style.padding = '0.2rem';
                iconLabels[index].style.width = '4rem';
                iconLabels[index].style.height = '4rem';

                document.querySelector('#property-custom-icon').value = '';
                const fileDisclaimer = document.getElementById('file-disclaimer');
                const uploadLabel = document.getElementById('upload-label');
                const labelAbbr = document.getElementById('label-abbr');
                fileDisclaimer.textContent = 'Only Accepting files lesser than 10MB';
                fileDisclaimer.style.fontWeight = 'normal';
                labelAbbr.title = '';
                uploadLabel.textContent = uploadLabel.dataset.labelValue;
            });
        });
    }
}
customElements.define('icon-picker', IconPicker);

function updatePrice(e, formName = "") {
    console.log("Update Price Function Fired"); // Debugging line
    const iconPrice = document.querySelector(`#${formName}-icon-price`).value;
    const customPrice = document.querySelector(`#${formName}-custom-icon-price`).value;
    const updatePrice = document.querySelector(`#${formName}-form-price`);

    if (e.target.type === 'radio') {
        updatePrice.textContent = iconPrice;
    } else {
        updatePrice.textContent = customPrice;
    }
}

document.querySelector('#secondary-property-custom-icon').addEventListener('click', (e) => {
    updatePrice(e, 'secondary');
});

document.querySelector('#tertiary-property-custom-icon').addEventListener('click', (e) => {
    updatePrice(e, 'tertiary');
});



class TertiaryIconPicker extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const iconInputs = this.querySelectorAll('.tertiary-icon-input');
        const iconLabels = this.querySelectorAll('.tertiary-icon-label');
        const selectedIconSpan = this.querySelector('#selected-icon');

        // Initialize the selected icon and border on page load
        initialRadioCheckForIcon(this, selectedIconSpan);

        iconInputs.forEach((input, index) => {
            input.addEventListener('change', (e) => {
                updatePrice(e, 'tertiary');
                
                // Hide icon error when an icon is selected
                const iconError = document.querySelector("#tertiary-icon-error");
                if (iconError) {
                    iconError.classList.add('tw-hidden');
                }
                
                const formData = JSON.parse(localStorage.getItem('formData') || '{}');
                if (formData) {
                    formData.customIcon = '';
                    localStorage.setItem('formData', JSON.stringify(formData));
                    document.getElementById('property-custom-icon').value = '';
                }
                selectedIconSpan.textContent = input.value;
                // Remove the styles from all labels
                iconLabels.forEach(label => {
                    label.style.border = '0';
                    label.style.padding = 0;
                    label.style.width = '3.6rem';
                    label.style.height = '3.6rem';
                });
                // Add Styles to the selected label
                iconLabels[index].style.border = '0.1rem solid #292C35';
                iconLabels[index].style.padding = '0.2rem';
                iconLabels[index].style.width = '4rem';
                iconLabels[index].style.height = '4rem';

                document.querySelector('#property-custom-icon').value = '';
                const tertiaryForm = document.querySelector('tertiary-form');
                const fileDisclaimer = tertiaryForm.querySelector('#file-disclaimer');
                const uploadLabel = tertiaryForm.querySelector('#upload-label');
                const labelAbbr = tertiaryForm.querySelector('#label-abbr');
                fileDisclaimer.textContent = 'Only Accepting files lesser than 10MB';
                fileDisclaimer.style.fontWeight = 'normal';
                labelAbbr.title = '';
                uploadLabel.textContent = uploadLabel.dataset.labelValue;
            });
        });
    }
}

customElements.define('tertiary-icon-picker', TertiaryIconPicker);

class FontPicker extends HTMLElement {

    constructor() {
        super();
    }

    connectedCallback() {
        const fontInputs = this.querySelectorAll('.font-input');
        const fontLabels = this.querySelectorAll('.font-label');
        const selectedFontSpan = this.querySelector('#selected-font');

        initialRadioCheckForFont(this, selectedFontSpan);

        fontInputs.forEach((input, index) => {
            input.addEventListener('change', () => {
                selectedFontSpan.textContent = input.value;
                // Remove the styles from all labels
                fontLabels.forEach(label => {
                    label.style.border = '0.1rem solid #808080';
                });
                // Add Styles to the selected label
                fontLabels[index].style.border = '0.2rem solid #292c35';
            });
        });
    }
}

customElements.define('font-picker', FontPicker);

class TertiaryFontPicker extends HTMLElement {

    constructor() {
        super();
    }

    connectedCallback() {
        const fontInputs = this.querySelectorAll('.tertiary-font-input');
        const fontLabels = this.querySelectorAll('.tertiary-font-label');
        const selectedFontSpan = this.querySelector('#selected-font');

        initialRadioCheckForFont(this, selectedFontSpan);

        fontInputs.forEach((input, index) => {
            input.addEventListener('change', () => {
                selectedFontSpan.textContent = input.value;
                // Remove the styles from all labels
                fontLabels.forEach(label => {
                    label.style.border = '0.1rem solid #808080';
                });
                // Add Styles to the selected label
                fontLabels[index].style.border = '0.2rem solid #292C35';
            });
        });
    }
}

customElements.define('tertiary-font-picker', TertiaryFontPicker);

//add by lise team to validate


function validateRequiredFields(formType) {
    let hasErrors = false;
    
    if (formType === 'Name') {
        const nameField = document.getElementById('name');
        const colorField = document.querySelector('.primary__form .radio__color input[name="color"]:checked');
        
        // Check if name is empty
        if (!nameField || !nameField.value.trim()) {
            document.querySelector("#primary-error-message").classList.remove("tw-hidden");
            hasErrors = true;
        } else {
            document.querySelector("#primary-error-message").classList.add("tw-hidden");
        }
        
        // Check if color is selected
        if (!colorField) {
            let colorError = document.querySelector("#primary-color-error");
            if (!colorError) {
                colorError = document.createElement('small');
                colorError.id = 'primary-color-error';
                colorError.className = 'tw-text-[#ff0000] tw-font-secondary';
                colorError.textContent = 'Please select a font color';
                
                const colorPicker = document.querySelector('.primary__form color-picker');
                if (colorPicker) {
                    colorPicker.insertAdjacentElement('afterend', colorError);
                } else {
                    document.querySelector('.primary__form .radio__color').insertAdjacentElement('afterend', colorError);
                }
            }
            colorError.classList.remove('tw-hidden');
            hasErrors = true;
        } else {
            const colorError = document.querySelector("#primary-color-error");
            if (colorError) {
                colorError.classList.add('tw-hidden');
            }
        }
        
        if (hasErrors) {
            if (!nameField || !nameField.value.trim()) {
                document.querySelector("#primary-error-message").scrollIntoView({ behavior: "smooth", block: "center" });
            } else if (!colorField) {
                document.querySelector("#primary-color-error").scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }
        
        return !hasErrors;
    }
    
    if (formType === 'Name and Icon') {
        const nameField = document.querySelector('.tertiary__form #name');
        const colorField = document.querySelector('.tertiary__form .radio__color input[name="color"]:checked');
        
        // Check if name is empty
        if (!nameField || !nameField.value.trim()) {
            document.querySelector('#tertiary-error-message').classList.remove('tw-hidden');
            hasErrors = true;
        } else {
            document.querySelector('#tertiary-error-message').classList.add('tw-hidden');
        }
        
        // Check if color is selected
        if (!colorField) {
            let colorError = document.querySelector("#tertiary-color-error");
            if (!colorError) {
                colorError = document.createElement('small');
                colorError.id = 'tertiary-color-error';
                colorError.className = 'tw-text-[#ff0000] tw-font-secondary';
                colorError.textContent = 'Please select a font color';
                
                const tertiaryColorPicker = document.querySelector('.tertiary__form tertiary-color-picker');
                if (tertiaryColorPicker) {
                    tertiaryColorPicker.insertAdjacentElement('afterend', colorError);
                } else {
                    document.querySelector('.tertiary__form .radio__color').insertAdjacentElement('afterend', colorError);
                }
            }
            colorError.classList.remove('tw-hidden');
            hasErrors = true;
        } else {
            const colorError = document.querySelector("#tertiary-color-error");
            if (colorError) {
                colorError.classList.add('tw-hidden');
            }
        }
        
        // Check if either an icon is selected OR a custom icon is uploaded
        const selectedIcon = document.querySelector('.tertiary__form input[name="icon"]:checked');
        const customIconInput = document.getElementById('property-custom-icon');
        const hasCustomIcon = customIconInput && customIconInput.files && customIconInput.files.length > 0;
        
        if (!selectedIcon && !hasCustomIcon) {
            let iconError = document.querySelector("#tertiary-icon-error");
            if (!iconError) {
                iconError = document.createElement('small');
                iconError.id = 'tertiary-icon-error';
                iconError.className = 'tw-text-[#ff0000] tw-font-secondary';
                iconError.textContent = 'Please select an icon or upload a custom icon';
                
                // Insert after the custom logo section
                const customLogoSection = document.querySelector('.tertiary__form .custom__logo');
                if (customLogoSection) {
                    customLogoSection.insertAdjacentElement('afterend', iconError);
                }
            }
            iconError.classList.remove('tw-hidden');
            hasErrors = true;
        } else {
            const iconError = document.querySelector("#tertiary-icon-error");
            if (iconError) {
                iconError.classList.add('tw-hidden');
            }
        }
        
        // Scroll to the first error
        if (hasErrors) {
            if (!nameField || !nameField.value.trim()) {
                document.querySelector('#tertiary-error-message').scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else if (!colorField) {
                document.querySelector("#tertiary-color-error").scrollIntoView({ behavior: 'smooth', block: "center" });
            } else if (!selectedIcon && !hasCustomIcon) {
                document.querySelector("#tertiary-icon-error").scrollIntoView({ behavior: 'smooth', block: "center" });
            }
        }
        
        return !hasErrors;
    }
    
    // FIXED: Icon-only form validation with proper selectors
    if (formType === 'Icon') {
        // Use specific selectors for secondary form
        const selectedIcon = document.querySelector('.secondary__form input[name="icon"]:checked') || 
                            document.querySelector('.icon-input:checked');
        const customIconInput = document.getElementById('property-custom-icon');
        const hasCustomIcon = customIconInput && customIconInput.files && customIconInput.files.length > 0;
        
        // Debug logging
        console.log('Secondary form validation:');
        console.log('Selected icon:', selectedIcon);
        console.log('Has custom icon:', hasCustomIcon);
        console.log('Custom icon input:', customIconInput);
        console.log('Custom icon files:', customIconInput ? customIconInput.files : 'No input');
        
        if (!selectedIcon && !hasCustomIcon) {
            let iconError = document.querySelector("#secondary-icon-error");
            if (!iconError) {
                iconError = document.createElement('small');
                iconError.id = 'secondary-icon-error';
                iconError.className = 'tw-text-[#ff0000] tw-font-secondary tw-block tw-mt-4';
                iconError.textContent = 'Please select an icon or upload a custom icon';
                
                // Insert after the custom logo section in secondary form
                const customLogoSection = document.querySelector('.secondary__form .custom__logo');
                if (customLogoSection) {
                    customLogoSection.insertAdjacentElement('afterend', iconError);
                } else {
                    // Fallback: insert after the form wrapper
                    const formWrapper = document.querySelector('.secondary__form');
                    if (formWrapper) {
                        formWrapper.appendChild(iconError);
                    }
                }
            }
            iconError.classList.remove('tw-hidden');
            hasErrors = true;
        } else {
            const iconError = document.querySelector("#secondary-icon-error");
            if (iconError) {
                iconError.classList.add('tw-hidden');
            }
        }
        
        if (hasErrors) {
            const iconError = document.querySelector("#secondary-icon-error");
            if (iconError) {
                iconError.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
        
        return !hasErrors;
    }
    
    return true;
}
class AddButton extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', () => {
            this.addToStorage();
        });
    }

    addToStorage() {
        // Enhanced validation that includes icon selection
        if (!validateRequiredFields(this.dataset.form)) {
            return;
        }

        // Clear previous form data to avoid mixing
        clearFormData(this.dataset.form);

        // Name form handling
        if (this.dataset.form == 'Name') {
            const formData = {
                textplacementValue: document.getElementById('placementValue').textContent,
                name: document.getElementById('name').value,
                designation: document.getElementById('designation').value,
                color: document.querySelector('.primary__form .radio__color input[name="color"]:checked').value,
                font: document.querySelector('.primary__form .radio__fonts input[name="font"]:checked').value,
                price: document.querySelector('#primary-form-price').textContent,
                formName: this.dataset.form,
                // Explicitly set icon fields to empty
                icon: '',
                customIcon: '',
                iconplacementValue: ''
            };      
            
            // Store form data in cookie
            setCookie('formData', formData);
            setCookie('color-name', document.querySelector('[data-color-value]:checked').dataset.colorValue);
            
            const formElement = document.querySelector('[data-product-form]');
            submitFormToLineProperties(formElement);
            bundlePersonalization(formElement);
            checkLocalStorage();
            document.querySelector('.close__icon').click();
            resetSecondaryForm();
        }

        // Icon form handling
        if (this.dataset.form == 'Icon') {
            const fileInput = document.getElementById('property-custom-icon');
            const hasFile = fileInput.files.length > 0;
            const selectedIcon = document.querySelector('input[name="icon"]:checked');
            
            // Ensure either an icon is selected or a custom icon is uploaded
            if (!hasFile && !selectedIcon) {
                // This should be caught by validation, but double-check
                let iconError = document.querySelector("#secondary-icon-error");
                if (iconError) {
                    iconError.classList.remove('tw-hidden');
                    iconError.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
                return;
            }
            
            // Handle case when a custom icon is uploaded
            if (hasFile) {
                const file = fileInput.value;
                const dataFile = fileInput.files[0];
                const reader = new FileReader();
                
                reader.onload = () => {
                    // Uncheck any selected icon radio buttons
                    document.querySelectorAll('input[name="icon"]').forEach((input) => {
                        input.checked = false;
                    });
                    
                    const customIconBase64 = reader.result;
                    const formData = {
                        price: document.querySelector('#secondary-custom-icon-price').value,
                        formName: this.dataset.form,
                        iconplacementValue: document.getElementById('secondary-placement').textContent,
                        icon: '',
                        customIcon: file,
                        previewCustomIcon: customIconBase64,
                        // Explicitly set name fields to empty
                        name: '',
                        designation: '',
                        textplacementValue: ''
                    };
                    
                    // Store in localStorage for the custom icon preview
                    localStorage.setItem('formData', JSON.stringify(formData));
                    
                    // Also store basic data in cookie (without the base64 image)
                    setCookie('formData', {
                        price: formData.price,
                        formName: formData.formName,
                        iconplacementValue: formData.iconplacementValue,
                        customIcon: file,
                        // Explicitly set name fields to empty
                        name: '',
                        designation: '',
                        textplacementValue: ''
                    });
                    
                    // Store color data
                    const colorValue = document.querySelector('[data-color-value]:checked');
                    if (colorValue) {
                        setCookie('color-name', colorValue.dataset.colorValue);
                    }
                    
                    // Update form properties and UI
                    const formElement = document.querySelector('[data-product-form]');
                    submitFormToLineProperties(formElement);
                    bundlePersonalization(formElement);
                    checkLocalStorage();
                    document.querySelector('.close__icon').click();
                    resetPrimaryForm();
                };
                
                reader.readAsDataURL(dataFile);
            } 
            // Handle case when a standard icon is selected
            else if (selectedIcon) {
                const formData = {
                    price: document.querySelector('#secondary-icon-price').value,
                    formName: this.dataset.form,
                    iconplacementValue: document.getElementById('secondary-placement').textContent,
                    icon: selectedIcon.dataset.img,
                    customIcon: '',
                    // Explicitly set name fields to empty
                    name: '',
                    designation: '',
                    textplacementValue: ''
                };
                
                // Store form data in cookie
                setCookie('formData', formData);
                
                // Store color data
                const colorValue = document.querySelector('[data-color-value]:checked');
                if (colorValue) {
                    setCookie('color-name', colorValue.dataset.colorValue);
                }
                
                // Update form properties and UI
                const formElement = document.querySelector('[data-product-form]');
                submitFormToLineProperties(formElement);
                bundlePersonalization(formElement);
                checkLocalStorage();
                document.querySelector('.close__icon').click();
                resetPrimaryForm();
            }
        }

        // Name and Icon form handling (handled by TertiaryForm component, but keeping for completeness)
        if (this.dataset.form == 'Name and Icon') {
            // This form type is typically handled by the TertiaryForm component
            // But we can add handling here if needed
            const nameField = document.querySelector('.tertiary__form #name');
            const colorField = document.querySelector('.tertiary__form input[name="color"]:checked');
            const fontField = document.querySelector('.tertiary__form input[name="font"]:checked');
            const fileInput = document.getElementById('property-custom-icon');
            const selectedIcon = document.querySelector('.tertiary__form input[name="icon"]:checked');
            const hasFile = fileInput && fileInput.files.length > 0;

            // Ensure all required fields are filled
            if (!nameField || !nameField.value.trim()) {
                document.querySelector('#tertiary-error-message').classList.remove('tw-hidden');
                document.querySelector('#tertiary-error-message').scrollIntoView({ behavior: 'smooth', block: 'center' });
                return;
            }

            if (!colorField) {
                const colorError = document.querySelector("#tertiary-color-error");
                if (colorError) {
                    colorError.classList.remove('tw-hidden');
                    colorError.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
                return;
            }

            // Ensure either an icon is selected or a custom icon is uploaded
            if (!hasFile && !selectedIcon) {
                const iconError = document.querySelector("#tertiary-icon-error");
                if (iconError) {
                    iconError.classList.remove('tw-hidden');
                    iconError.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
                return;
            }

            // Handle custom icon upload
            if (hasFile) {
                const file = fileInput.value;
                const dataFile = fileInput.files[0];
                const reader = new FileReader();

                reader.onload = () => {
                    // Uncheck any selected icon radio buttons
                    document.querySelectorAll('.tertiary__form input[name="icon"]').forEach((input) => {
                        input.checked = false;
                    });
                    
                    const customIconBase64 = reader.result;
                    const formData = {
                        name: nameField.value,
                        designation: document.querySelector('.tertiary__form #designation').value || '',
                        color: colorField.value,
                        font: fontField.value,
                        price: document.querySelector('#tertiary-custom-icon-price').value,
                        formName: 'Name and Icon',
                        textplacementValue: document.querySelector('#text-placement').textContent,
                        iconplacementValue: document.querySelector('#icon-placement').textContent,
                        icon: '',
                        customIcon: file,
                        previewCustomIcon: customIconBase64
                    };

                    // Store custom icon in localStorage
                    localStorage.setItem('formData', JSON.stringify(formData));
                    
                    // Store color in cookie
                    setCookie('color-name', colorField.dataset.colorValue);
                    
                    // Store other form data in cookie
                    setCookie('formData', {
                        name: formData.name,
                        designation: formData.designation,
                        color: formData.color,
                        font: formData.font,
                        price: formData.price,
                        formName: formData.formName,
                        textplacementValue: formData.textplacementValue,
                        iconplacementValue: formData.iconplacementValue,
                        icon: formData.icon,
                        customIcon: file
                    });

                    const formElement = document.querySelector('[data-product-form]');
                    submitFormToLineProperties(formElement);
                    bundlePersonalization(formElement);
                    checkLocalStorage();
                    document.querySelector('.close__icon').click();
                };

                reader.readAsDataURL(dataFile);
            }
            // Handle standard icon selection
            else if (selectedIcon) {
                const formData = {
                    name: nameField.value,
                    designation: document.querySelector('.tertiary__form #designation').value || '',
                    color: colorField.value,
                    font: fontField.value,
                    price: document.querySelector('#tertiary-icon-price').value,
                    formName: 'Name and Icon',
                    textplacementValue: document.querySelector('#text-placement').textContent,
                    iconplacementValue: document.querySelector('#icon-placement').textContent,
                    icon: selectedIcon.dataset.img,
                    customIcon: ''
                };

                // Store color in cookie
                setCookie('color-name', colorField.dataset.colorValue);
                
                // Store form data in cookie
                setCookie('formData', formData);

                const formElement = document.querySelector('[data-product-form]');
                submitFormToLineProperties(formElement);
                bundlePersonalization(formElement);
                checkLocalStorage();
                document.querySelector('.close__icon').click();
                resetPrimaryForm();
                resetSecondaryForm();
            }
        }
    }
}

customElements.define('add-button', AddButton);


function clearFormData(formType) {
    // Get current form data, if any
    const formData = getCookie('formData') || 
                    (localStorage.getItem('formData') ? 
                    JSON.parse(localStorage.getItem('formData')) : 
                    null);
    
    if (!formData) return; // No data to clear
    
    // Create a new object with only the relevant fields for the specified form type
    let newFormData = {};
    
    if (formType === 'Name') {
        // Only keep name-related fields, removing any icon data
        if (formData.name) newFormData.name = formData.name;
        if (formData.designation) newFormData.designation = formData.designation;
        if (formData.color) newFormData.color = formData.color;
        if (formData.font) newFormData.font = formData.font;
        if (formData.textplacementValue) newFormData.textplacementValue = formData.textplacementValue;
        newFormData.formName = 'Name';
        if (formData.price) newFormData.price = formData.price;
        
        // Explicitly remove any icon-related data
        newFormData.icon = '';
        newFormData.customIcon = '';
        newFormData.iconplacementValue = '';
    } 
    else if (formType === 'Icon') {
        // Only keep icon-related fields, removing any name data
        if (formData.icon) newFormData.icon = formData.icon;
        if (formData.customIcon) newFormData.customIcon = formData.customIcon;
        if (formData.iconplacementValue) newFormData.iconplacementValue = formData.iconplacementValue;
        newFormData.formName = 'Icon';
        if (formData.price) newFormData.price = formData.price;
        
        // Explicitly remove any name-related data
        newFormData.name = '';
        newFormData.designation = '';
        newFormData.textplacementValue = '';
    }
    else if (formType === 'Name and Icon') {
        // Keep all fields for the combined form
        newFormData = {...formData};
        newFormData.formName = 'Name and Icon';
    }
    
    // Update storage with the filtered data
    setCookie('formData', newFormData);
    localStorage.setItem('formData', JSON.stringify(newFormData));
}




class ResetButton extends HTMLElement {
    constructor() {
        super();
        this.buttonValue = this.dataset.button;
        this.addEventListener('click', () => {
            if (this.buttonValue == 'primary') {
                resetPrimaryForm();
            }
            if (this.buttonValue == 'secondary') {
                resetSecondaryForm();
            }
        });
    }

}
customElements.define('reset-button', ResetButton);

function resetPrimaryForm() {
    document.getElementById('primary-form').reset();

    const colorRadios = document.querySelectorAll('.color-input');
    const fontRadios = document.querySelectorAll('.font-input');

    const colorLabels = document.querySelectorAll('.color-label');
    const fontLabels = document.querySelectorAll('.font-label');

    // Uncheck all radio buttons
    colorRadios.forEach(radio => radio.checked = false);
    fontRadios.forEach(radio => radio.checked = false);

    // Don't automatically check any color
    // document.getElementById('color#1').checked = true;  // Remove this line
    document.getElementById('font#1').checked = true;

    // Reset the styles for all color labels
    colorLabels.forEach(label => {
        label.style.border = 0;
        label.style.padding = 0;
        label.style.width = '3.2rem';
        label.style.height = '1.6rem';
        label.style.outline = 'none';
    });

    // Reset the styles for all font labels
    fontLabels.forEach(label => {
        label.style.border = 'none';
    });

    // Hide error messages
    document.querySelector("#primary-error-message").classList.add("tw-hidden");
    const colorError = document.querySelector("#primary-color-error");
    if (colorError) {
        colorError.classList.add("tw-hidden");
    }

    // Clear selected color text
    const selectedColorSpan = document.getElementById('selected-color');
    if (selectedColorSpan) {
        selectedColorSpan.textContent = '';
    }

    // Don't call initialRadioCheckForColor
    // initialRadioCheckForColor(document, document.getElementById('selected-color'));
    initialRadioCheckForFont(document, document.getElementById('selected-font'));
}

function resetSecondaryForm() {
    document.querySelector('.secondary__form').reset();

    const radioIcons = document.querySelectorAll('.icon-input');
    const iconLabels = document.querySelectorAll('.icon-label');
    const uploadLabel = document.getElementById('upload-label');
    const fileDisclaimer = document.getElementById('file-disclaimer');
    const labelAbbr = document.getElementById('label-abbr');
    uploadLabel.textContent = uploadLabel.dataset.labelValue;
    if(document.querySelector('[name="properties[Icon]"]')) {
        document.querySelector('[name="properties[Icon]"]').value = '';
    }
    if(document.querySelector('[name="properties[IconPlacement]"]')){
        document.querySelector('[name="properties[IconPlacement]"]').value = '';
    }
    document.getElementById('property-custom-icon').value = '';
    fileDisclaimer.textContent = 'Only Accepting files lesser than 10MB';
    fileDisclaimer.style.fontWeight = 'normal';
    labelAbbr.title = '';

    radioIcons.forEach(radio => radio.checked = false);

    document.getElementById('icon-1').checked = true;

    iconLabels.forEach(label => {
        label.style.border = '0';
        label.style.padding = 0;
        label.style.width = '3.6rem';
        label.style.height = '3.6rem';
    })

    initialRadioCheckForIcon(document, document.getElementById('selected-icon'));
}


class TertiaryForm extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const resetButton = document.getElementById('tertiary-reset');
        if (resetButton) {
            resetButton.addEventListener('click', () => this.resetTertiaryForm());
        }

        const addButton = document.getElementById('tertiary-submit');
        if (addButton) {
            addButton.addEventListener('click', () => this.addDataToStorage());
        }
    }

    addDataToStorage() {
        // Validate required fields first
        if (!validateRequiredFields('Name and Icon')) {
            return;
        }

        // Clear previous form data to avoid mixing
        clearFormData('Name and Icon');
        
        const fileInput = document.querySelector('#property-custom-icon');

        const file = fileInput.value;
        const dataFile = fileInput.files[0];
        const reader = new FileReader();

        reader.onload = () => {
            this.querySelectorAll('input[name="icon"]').forEach((input) => {
                input.removeAttribute('checked');
            });
            
            const customIconBase64 = reader.result;

            const formData = {
                name: this.querySelector('#name').value,
                designation: this.querySelector('#designation').value,
                color: this.querySelector('input[name="color"]:checked').value,
                font: this.querySelector('input[name="font"]:checked').value,
                price: document.querySelector('#tertiary-custom-icon-price').value,
                formName: 'Name and Icon', // Hardcoded as 'Name and Icon'
                textplacementValue: this.querySelector('#text-placement').textContent,
                iconplacementValue: this.querySelector('#icon-placement').textContent,
                icon: this.querySelector('input[name="icon"]:checked') ? this.querySelector('input[name="icon"]:checked').dataset.img : '',
                customIcon: file,
                previewCustomIcon: customIconBase64
            };

            if(formData.name) {
                // Store custom icon in localStorage
                localStorage.setItem('formData', JSON.stringify(formData));
                
                // Store color in cookie
                setCookie('color-name', this.querySelector('input[name="color"]:checked').dataset.colorValue);
                
                // Store other form data in cookie
                setCookie('formData', {
                    name: formData.name,
                    designation: formData.designation,
                    color: formData.color,
                    font: formData.font,
                    price: formData.price,
                    formName: formData.formName,
                    textplacementValue: formData.textplacementValue,
                    iconplacementValue: formData.iconplacementValue,
                    icon: formData.icon,
                    customIcon: file
                });

                const formElement = document.querySelector('[data-product-form]');
                submitFormToLineProperties(formElement);
                bundlePersonalization(formElement);
                checkLocalStorage();
                document.querySelector('.close__icon').click();
            }
            else {
                document.querySelector('#tertiary-error-message').classList.remove('tw-hidden');
                document.querySelector('#tertiary-error-message').scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        };

        if (dataFile) {
            reader.readAsDataURL(dataFile);
        }
        else {
            const formData = {
                name: this.querySelector('#name').value,
                designation: this.querySelector('#designation').value,
                color: this.querySelector('input[name="color"]:checked').value,
                font: this.querySelector('input[name="font"]:checked').value,
                price: document.querySelector('#tertiary-icon-price').value,
                formName: 'Name and Icon', // Hardcoded as 'Name and Icon'
                textplacementValue: this.querySelector('#text-placement').textContent,
                iconplacementValue: this.querySelector('#icon-placement').textContent,
                icon: this.querySelector('input[name="icon"]:checked') ? this.querySelector('input[name="icon"]:checked').dataset.img : '',
                customIcon: ''
            };

            if(formData.name) {
                // Store color in cookie
                setCookie('color-name', this.querySelector('input[name="color"]:checked').dataset.colorValue);
                
                // Store form data in cookie
                setCookie('formData', formData);

                const formElement = document.querySelector('[data-product-form]');
                submitFormToLineProperties(formElement);
                bundlePersonalization(formElement);
                checkLocalStorage();
                document.querySelector('.close__icon').click();
                resetPrimaryForm();
                resetSecondaryForm();
            }
            else {
                document.querySelector('#tertiary-error-message').classList.remove('tw-hidden');
                document.querySelector('#tertiary-error-message').scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    }

    resetTertiaryForm() {
        document.querySelector('.tertiary__form').reset();

        const colorRadios = this.querySelectorAll('.tertiary-color-input');
        const fontRadios = this.querySelectorAll('.tertiary-font-input');

        const colorLabels = this.querySelectorAll('.tertiary-color-label');
        const fontLabels = this.querySelectorAll('.tertiary-font-label');

        colorRadios.forEach(radio => radio.checked = false);
        fontRadios.forEach(radio => radio.checked = false);

        // Don't automatically check color - this is important
        // this.querySelector('#form_color_1').checked = true;  // Comment out or remove this line
        this.querySelector('#tertiary-font-1').checked = true;

        colorLabels.forEach(label => {
            label.style.border = '0';  // Reset to no border instead of setting border
            label.style.padding = 0;
            label.style.width = '3.2rem';
            label.style.height = '1.6rem';
            label.style.outline = 'none';
        });

        fontLabels.forEach(label => {
            label.style.border = '0.1rem solid #808080';
        });

        // Don't call initialRadioCheckForColor - this maintains no selection
        // initialRadioCheckForColor(this, this.querySelector('#selected-color'));
        
        // Clear the selected color display
        const selectedColorSpan = this.querySelector('#selected-color');
        if (selectedColorSpan) {
            selectedColorSpan.textContent = '';
        }
        
        initialRadioCheckForFont(this, this.querySelector('#selected-font'));

        const radioIcons = this.querySelectorAll('.tertiary-icon-input');
        const iconLabels = this.querySelectorAll('.tertiary-icon-label');
        const uploadLabelTertiary = this.querySelector('#upload-label');
        const fileDisclaimerTertiary = this.querySelector('#file-disclaimer');
        const labelAbbrTertiary = this.querySelector('#label-abbr');
        uploadLabelTertiary.textContent = uploadLabelTertiary.dataset.labelValue;
        document.getElementById('property-custom-icon').value = '';
        fileDisclaimerTertiary.textContent = 'Only Accepting files lesser than 10MB';
        fileDisclaimerTertiary.style.fontWeight = 'normal';
        labelAbbrTertiary.title = '';

        radioIcons.forEach(radio => radio.checked = false);

        document.getElementById('tertiary-icon-1').checked = true;

        iconLabels.forEach(label => {
            label.style.border = '0';
            label.style.padding = 0;
            label.style.width = '3.6rem';
            label.style.height = '3.6rem';
        });

        // Hide error messages
        document.querySelector('#tertiary-error-message').classList.add('tw-hidden');
        const colorError = document.querySelector("#tertiary-color-error");
        if (colorError) {
            colorError.classList.add('tw-hidden');
        }

        initialRadioCheckForIcon(this, this.querySelector('#selected-icon'));
        
        // Also clear stored data for this form
        clearFormData('Name and Icon');
    }
}

customElements.define('tertiary-form', TertiaryForm);

function checkLocalStorage() {
    // First, try to get data from cookies
    const savedFormData = getCookie('formData');
    const savedColorName = getCookie('color-name');

    // Try to get localStorage data for custom icon
    const localStorageFormData = localStorage.getItem('formData') 
        ? JSON.parse(localStorage.getItem('formData')) 
        : null;

    if (savedFormData) {
        // Hide personalization button and show details
        document.querySelector('.fit--dis__text').style.display = 'none';
        document.getElementById('personalization-btn').style.display = 'none';
        const personalizeDetails = document.getElementById('personalize-details');
        personalizeDetails.classList.remove('tw-hidden');
        personalizeDetails.classList.add('tw-flex');

        // Handle Name personalization
      if (savedFormData.formName == 'Name') {
    document.querySelector('.primary_form_preview').classList.remove('tw-hidden');
    document.querySelector('.primary_form_preview').classList.add('tw-flex');

    document.querySelector('.secondary_form_preview').classList.remove('tw-flex');
    document.querySelector('.secondary_form_preview').classList.add('tw-hidden');

    document.querySelector('.tertiary_form_preview').classList.remove('tw-flex');
    document.querySelector('.tertiary_form_preview').classList.add('tw-hidden');

    const placementValue = savedFormData.textplacementValue;
    const name = savedFormData.name;
    const designation = savedFormData.designation || '';
    const color = savedFormData.color;
    const font = savedFormData.font;
    const price = savedFormData.price; 
    
    // Update background color
    document.querySelectorAll('[data-bg-color-preview]').forEach((element) => {
        if(element.checked){
            document.getElementById('preview-primary-background').style.backgroundColor = element.dataset.bgColorPreview;
        }
    });

    // Set user name
    document.getElementById('user-name').textContent = name;
    
    // Find the input with the matching color name and get its data-color-value
    const matchingColorInput = document.querySelector(`input[name="color"][value="${savedFormData.color}"]`);
    if (matchingColorInput && matchingColorInput.dataset.colorValue) {
        document.getElementById('user-name').style.color = matchingColorInput.dataset.colorValue;
        document.getElementById('preview-designation-user').style.color = matchingColorInput.dataset.colorValue;
    }

    // Font styling
    document.getElementById('user-name').style.fontFamily = font === 'Script' ? 'Petit' : 'Gotham-Book';

    document.getElementById('preview-name').textContent = name;
    
    // Designation handling
    if(designation){
        document.getElementById('preview-designation-user').style.fontFamily = font === 'Script' ? 'Petit' : 'Gotham-Book';
        document.getElementById('preview-designation').textContent = ", " + designation;
        document.getElementById('preview-designation-user').textContent = designation;
    }
    else{
        document.getElementById('preview-designation').textContent = "";
        document.getElementById('preview-designation-user').textContent = "";
    }
    
    // Update other preview elements
    document.getElementById('text-color').textContent = color;
    document.getElementById('preview-font').textContent = font;
    document.getElementById('text-placement').textContent = placementValue;
    document.getElementById('price-value').textContent = price;
}

        // Handle Icon personalization
        else if (savedFormData.formName == 'Icon') {
            document.querySelector('.secondary_form_preview').classList.remove('tw-hidden');
            document.querySelector('.secondary_form_preview').classList.add('tw-flex');

            document.querySelector('.primary_form_preview').classList.remove('tw-flex');
            document.querySelector('.primary_form_preview').classList.add('tw-hidden');

            document.querySelector('.tertiary_form_preview').classList.remove('tw-flex');
            document.querySelector('.tertiary_form_preview').classList.add('tw-hidden');

            // Update background color
            document.querySelectorAll('[data-bg-color-preview]').forEach((element) => {
                if(element.checked){
                    document.getElementById('icon-holder').style.backgroundColor = element.dataset.bgColorPreview;
                }
            })

            const placementValue = savedFormData.iconplacementValue;
            let icon = savedFormData.icon;
            
            // Check for custom icon in localStorage or saved data
            const customIcon = localStorageFormData 
                ? localStorageFormData.previewCustomIcon 
                : (savedFormData.previewCustomIcon || null);
            
            const price = savedFormData.price;
            
            // Update price
            document.getElementById('price-value').textContent = price;

            // Handle icon display
            if (customIcon) {
                document.getElementById('preview-icon').src = customIcon;
                document.getElementById('icon-value').textContent = placementValue;
                document.getElementById('icon-type').textContent = 'Custom';
            }
            else if (icon) {
                const cdnURL = 'https://cdn.shopify.com/s/files/1/0869/7551/2851/'
                document.getElementById('preview-icon').src = `${cdnURL}${icon}`;
                document.getElementById('icon-value').textContent = placementValue;
                
                // Clean up icon name
                icon = icon.replace("files/", "")
                    .replace(".png", "")
                    .replace(".svg", "")
                    .replace(".jpg", "")
                    .replace(".jpeg", "");
                
                document.getElementById('icon-type').textContent = icon;
            }
        }

        // Handle Name and Icon personalization
       else if (savedFormData.formName == 'Name and Icon') {
    document.querySelector('.tertiary_form_preview').classList.remove('tw-hidden');
    document.querySelector('.tertiary_form_preview').classList.add('tw-flex');

    document.querySelector('.primary_form_preview').classList.remove('tw-flex');
    document.querySelector('.primary_form_preview').classList.add('tw-hidden');

    document.querySelector('.secondary_form_preview').classList.remove('tw-flex');
    document.querySelector('.secondary_form_preview').classList.add('tw-hidden');

    const textplacementValue = savedFormData.textplacementValue;
    let icon = savedFormData.icon;
    
    // Check for custom icon in localStorage
    const customIcon = localStorageFormData ? localStorageFormData.previewCustomIcon : null;
    const iconplacementValue = savedFormData.iconplacementValue;
    const name = savedFormData.name;
    const designation = savedFormData.designation || '';
    const color = savedFormData.color;
    const font = savedFormData.font;
    const price = savedFormData.price;

    // Update background color
    document.querySelectorAll('[data-bg-color-preview]').forEach((element) => {
        if(element.checked){
            document.querySelector('.tertiary_form_preview #preview-primary-background').style.backgroundColor = element.dataset.bgColorPreview;
            document.querySelector('.tertiary_form_preview #icon-holder').style.backgroundColor = element.dataset.bgColorPreview;
        }
    });
    
    // Find the input with the matching color name and get its data-color-value
    const matchingColorInput = document.querySelector(`input[name="color"][value="${savedFormData.color}"]`);
    if (matchingColorInput && matchingColorInput.dataset.colorValue) {
        document.getElementById('tertiary-user-name').style.color = matchingColorInput.dataset.colorValue;
        document.getElementById('tertiary-preview-designation-user').style.color = matchingColorInput.dataset.colorValue;
    }

    // Font styling
    document.getElementById('tertiary-user-name').style.fontFamily = font === 'Script' ? 'Petit' : 'Gotham-Book';

    // Update price and name
    document.getElementById('price-value').textContent = price;
    document.getElementById('tertiary-user-name').textContent = name;
    document.getElementById('tertiary-preview-name').textContent = name;
    
    // Designation handling
    if(designation){
        document.getElementById('tertiary-preview-designation-user').style.fontFamily = font === 'Script' ? 'Petit' : 'Gotham-Book';
        document.getElementById('tertiary-preview-designation').textContent = ", " + designation;
        document.getElementById('tertiary-preview-designation-user').textContent = designation;
    }
    else{
        document.getElementById('tertiary-preview-designation').textContent = '';
        document.getElementById('tertiary-preview-designation-user').textContent = '';
    }
    
    // Update other preview elements
    document.getElementById('tertiary-text-color').textContent = color;
    document.getElementById('tertiary-preview-font').textContent = font;
    document.getElementById('tertiary-text-placement').textContent = textplacementValue;

    // Handle icon display
    if (customIcon) {
        document.getElementById('tertiary-preview-icon').src = customIcon;
        document.getElementById('tertiary-icon-value').textContent = textplacementValue;
        document.getElementById('tertiary-icon-type').textContent = 'Custom';
    }
    else if (icon) {
        const cdnURL = 'https://cdn.shopify.com/s/files/1/0869/7551/2851/'
        document.getElementById('tertiary-preview-icon').src = `${cdnURL}${icon}`;
        document.getElementById('tertiary-icon-value').textContent = iconplacementValue;
        
        // Clean up icon name
        icon = icon.replace("files/", "")
            .replace(".png", "")
            .replace(".svg", "")
            .replace(".jpg", "")
            .replace(".jpeg", "");
        
        document.getElementById('tertiary-icon-type').textContent = icon;
    }
}
    }
    else {
        // Reset to default state when no personalization data exists
        if(document.querySelector('.fit--dis__text')){
            document.querySelector('.fit--dis__text').style.display = 'flex';
        }
        if(document.getElementById('personalization-btn')){
            document.getElementById('personalization-btn').style.display = 'flex';
        }
        const personalizeDetails = document.getElementById('personalize-details');
        if(personalizeDetails){
            personalizeDetails.classList.remove('tw-flex');
            personalizeDetails.classList.add('tw-hidden');
        }
    }
}
function initialRadioCheckForColor(selector, selectedItem) {
    let checkedInput;
    if(!selector.querySelector(".color-input")){
        checkedInput = selector.querySelector(".tertiary-color-input:checked");
    }
    else{
        checkedInput = selector.querySelector(".color-input:checked");
    }
    
    // Only apply styling if there's a checked input
    if (checkedInput) {
        selectedItem.textContent = checkedInput.value;

        // Getting the label node for each input tag 
        const selectedLabel = checkedInput.previousElementSibling;
        if (selectedLabel) {
            selectedLabel.style.border = "0.1rem solid #f8f6f3";
            selectedLabel.style.width = '3.2rem';
            selectedLabel.style.height = '1.6rem';
            selectedLabel.style.outline = 'solid';
            selectedLabel.style.outlineWidth = '0.2rem';
            selectedLabel.style.outlineColor = '#808080';
        }
    } else {
        // If no color is selected, clear the display
        selectedItem.textContent = '';
    }
}

function initialRadioCheckForIcon(selector, selectedItem) {
    let initialSelectedInput;
    if(!selector.querySelector(".icon-input:checked")){
        initialSelectedInput = selector.querySelector(".tertiary-icon-input:checked");
    }
    else{
        initialSelectedInput = selector.querySelector(".icon-input:checked");
    }
    if (initialSelectedInput) {
        selectedItem.textContent = initialSelectedInput.value;

        const initialSelectedLabel = initialSelectedInput.closest('label');
        if (initialSelectedLabel) {
            initialSelectedLabel.style.border = "0.1rem solid #292C35";
            initialSelectedLabel.style.padding = "0.2rem";
            initialSelectedLabel.style.width = '4rem';
            initialSelectedLabel.style.height = '4rem';
        }
    }
    else {
        const iconLabels = selector.querySelectorAll('.icon-label');
        iconLabels.forEach(label => {
            label.style.border = '0';
            label.style.padding = 0;
            label.style.width = '3.6rem';
            label.style.height = '3.6rem';
        });
    }
}

function initialRadioCheckForFont(selector, selectedItem) {
    let initialSelectedInput;
    if(!selector.querySelector(".font-input:checked")){
        initialSelectedInput = selector.querySelector(".tertiary-font-input:checked")
    }
    else{
        initialSelectedInput = selector.querySelector(".font-input:checked");
    }
    if (initialSelectedInput) {
        selectedItem.textContent = initialSelectedInput.value;
        const initialSelectedLabel = initialSelectedInput.previousElementSibling;
        if (initialSelectedLabel) {
            initialSelectedLabel.style.border = "0.2rem solid #292c35";
        }
    }
}

class DeleteIcon extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', this.deleteData.bind(this));
    }
    
    deleteData(){
        // Remove cookies and localStorage
        removeCookie('formData');
        removeCookie('color-name');
        localStorage.removeItem('formData');
        
        checkLocalStorage();
        removeAllInputs();
        resetPrimaryForm();
        resetSecondaryForm();
    }
}
customElements.define('delete-icon', DeleteIcon);



document.addEventListener('DOMContentLoaded', () => {
    checkLocalStorage();
    const formElement = document.querySelector('[data-product-form]');
    submitFormToLineProperties(formElement);
    if(localStorage.getItem('bundleBody')){
        bundlePersonalization(formElement);
    }
});

// Modified submitFormToLineProperties function
async function submitFormToLineProperties(formElement) {
    // Try to get form data from cookies first, then localStorage
    const formData = getCookie('formData') || 
                     (localStorage.getItem('formData') ? 
                      JSON.parse(localStorage.getItem('formData')) : 
                      null);
                      
    // Store localStorage data in a variable to use later
    const localStorageFormData = localStorage.getItem('formData') ? 
                                JSON.parse(localStorage.getItem('formData')) : 
                                null;

    if (formElement) {
        // First, clear all form properties to avoid data persistence
        const nameInput = document.getElementById('property-name');
        if (nameInput) nameInput.value = "";
        
        const designationInput = document.getElementById('property-designation');
        if (designationInput) designationInput.value = "";
        
        const colorInput = document.getElementById('property-color');
        if (colorInput) colorInput.value = "";
        
        const fontInput = document.getElementById('property-font');
        if (fontInput) fontInput.value = "";
        
        const formNameInput = document.getElementById('property-formName');
        if (formNameInput) formNameInput.value = "";
        
        const placementInput = document.getElementById('property-textplacementValue');
        if (placementInput) placementInput.value = "";
        
        const iconPlacementInput = document.getElementById('property-iconplacementValue');
        if (iconPlacementInput) iconPlacementInput.value = "";

        // Remove any existing icon inputs
        if(formElement.querySelector('[name="properties[Icon]"]')) {
            formElement.querySelector('[name="properties[Icon]"]').remove();
        }
        if(formElement.querySelector('[name="properties[Icon Type]"]')) {
            formElement.querySelector('[name="properties[Icon Type]"]').remove();
        }
        if(formElement.querySelector('[name="properties[Custom Icon]"]')) {
            formElement.querySelector('[name="properties[Custom Icon]"]').remove();
        }
    }

    if (formData) {
        // Name handling - only set if the form includes name data
        if (formData.formName === 'Name' || formData.formName === 'Name and Icon') {
            if (formData.name) {
                const nameInput = document.getElementById('property-name');
                if (nameInput) {
                    nameInput.value = formData.name;
                }
            }
            
            // Designation handling - separate from name
            if (formData.designation) {
                const designationInput = document.getElementById('property-designation');
                if (designationInput) {
                    designationInput.value = formData.designation;
                }
            }

            // Color handling
            if (formData.color) {
                const colorInput = document.getElementById('property-color');
                if (colorInput) {
                    colorInput.value = formData.color;
                }
            }

            // Font handling
            if (formData.font) {
                const fontInput = document.getElementById('property-font');
                if (fontInput) {
                    fontInput.value = formData.font;
                }
            }

            // Placement Value handling
            if (formData.textplacementValue) {
                const placementInput = document.getElementById('property-textplacementValue');
                if (placementInput) {
                    placementInput.value = formData.textplacementValue;
                }
            }
        }

        // Form Name handling - always set this
        if (formData.formName) {
            const formNameInput = document.getElementById('property-formName');
            if (formNameInput) {
                formNameInput.value = formData.formName;
            }
        }

        // Icon handling - only set if the form includes icon data
        if (formData.formName === 'Icon' || formData.formName === 'Name and Icon') {
            // Icon Placement handling
            if (formData.iconplacementValue) {
                const iconPlacementInput = document.getElementById('property-iconplacementValue');
                if (iconPlacementInput) {
                    iconPlacementInput.value = formData.iconplacementValue;
                }
            }

            // Icon handling for predefined icons
            if (formData.icon) {
                try {
                    const iconPath = `https://cdn.shopify.com/s/files/1/0869/7551/2851/${formData.icon}`;
                    const file = await urlToFile(iconPath, 'icon.png', 'image/png');
                    
                    // Create icon input
                    const input = document.createElement('input');
                    input.type = 'file';
                    input.name = 'properties[Icon]';
                    input.classList.add('tw-hidden');
                    input.setAttribute('form', formElement.dataset.productForm);
                    const dataTransfer = new DataTransfer();
                    dataTransfer.items.add(file);
                    input.files = dataTransfer.files;
                    formElement.appendChild(input);

                    // Create icon type input
                    const input2 = document.createElement('input');
                    input2.type = 'hidden';
                    input2.name = 'properties[Icon Type]';
                    input2.setAttribute('form', formElement.dataset.productForm);
                    let iconName = formData.icon
                        .replace("files/", "")
                        .replace(".png", "")
                        .replace(".svg", "")
                        .replace(".jpg", "")
                        .replace(".jpeg", "");
                    input2.value = capitalizeFirstLetter(iconName);

                    const iconPlacementInput = document.getElementById('property-iconplacementValue');
                    if (iconPlacementInput) {
                        iconPlacementInput.parentNode.insertBefore(input2, iconPlacementInput);
                    }
                } catch (error) {
                    console.error("Error processing icon:", error);
                }
            }

            // Custom Icon handling - IMPROVED VERSION
            if (formData.customIcon || 
                (localStorageFormData && localStorageFormData.previewCustomIcon)) {
                try {
                    // Create custom icon type input
                    const input2 = document.createElement('input');
                    input2.type = 'hidden';
                    input2.name = 'properties[Icon Type]';
                    input2.setAttribute('form', formElement.dataset.productForm);
                    input2.value = `Custom`;

                    const iconPlacementInput = document.getElementById('property-iconplacementValue');
                    if (iconPlacementInput) {
                        iconPlacementInput.parentNode.insertBefore(input2, iconPlacementInput);
                    }

                    // Check if we have a base64 encoded image in localStorage
                    if (localStorageFormData && localStorageFormData.previewCustomIcon) {
                        // Convert base64 to file
                        const fileName = formData.customIcon ? formData.customIcon.split('\\').pop() : 'custom-icon.png';
                        const customIconFile = dataURLtoFile(localStorageFormData.previewCustomIcon, fileName);
                        
                        // Create a file input for the custom icon
                        const customIconInput = document.createElement('input');
                        customIconInput.type = 'file';
                        customIconInput.name = 'properties[Custom Icon]';
                        customIconInput.classList.add('tw-hidden');
                        customIconInput.setAttribute('form', formElement.dataset.productForm);
                        
                        // Add the file to the input
                        const dataTransfer = new DataTransfer();
                        dataTransfer.items.add(customIconFile);
                        customIconInput.files = dataTransfer.files;
                        
                        // Add the input to the form
                        formElement.appendChild(customIconInput);
                    } 
                    // If we have a file in the input, use that
                    else {
                        const fileInput = document.getElementById('property-custom-icon');
                        if (fileInput && fileInput.files.length > 0) {
                            // Create custom icon input
                            const customIconInput = document.createElement('input');
                            customIconInput.type = 'file';
                            customIconInput.name = 'properties[Custom Icon]';
                            customIconInput.classList.add('tw-hidden');
                            customIconInput.setAttribute('form', formElement.dataset.productForm);
                            
                            // Add the file to the input
                            const dataTransfer = new DataTransfer();
                            dataTransfer.items.add(fileInput.files[0]);
                            customIconInput.files = dataTransfer.files;
                            
                            // Add the input to the form
                            formElement.appendChild(customIconInput);
                        }
                    }
                } catch (error) {
                    console.error("Error processing custom icon:", error);
                }
            }
        }
    }
}

function dataURLtoFile(dataurl, filename) {
    const arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
}

async function urlToFile(url, filename, mimeType) {
    const response = await fetch(url);
    const blob = await response.blob();
    const file = new File([blob], filename, { type: mimeType });
    return file;
}

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}


function removeAllInputs() {
    const formElement = document.querySelector('[data-product-form]');
    formElement.querySelector('[name="properties[mainProduct]"]').value = "";
    formElement.querySelector('[name="properties[uniqueId]"]').value = "";
    formElement.querySelector('#property-name').value = ""
    formElement.querySelector('#property-designation').value = "";
    formElement.querySelector('#property-color').value = "";
    formElement.querySelector('#property-font').value = "";
    formElement.querySelector('#property-formName').value = "";
    formElement.querySelector('#property-textplacementValue').value = "";
    formElement.querySelector('#property-iconplacementValue').value = "";
    if(formElement.querySelector('[name="properties[Icon]"]')) {
        formElement.querySelector('[name="properties[Icon]"]').remove();
    }
    if(formElement.querySelector('[name="properties[Custom Icon]"]')) {
        formElement.querySelector('[name="properties[Custom Icon]"]').value = '';
    }

    // Remove cookies and localStorage
    removeCookie('formData');
    removeCookie('color-name');
    localStorage.removeItem('formData');
}


async function bundlePersonalization(element) {
    // Attempt to get form data from cookie first
    let formData = getCookie('formData');

    // If no cookie data, try localStorage for custom icon scenarios
    if (!formData) {
        const localStorageData = localStorage.getItem('formData');
        formData = localStorageData ? JSON.parse(localStorageData) : null;
    }

    const mainProductId = element.dataset.productId;
    const mainSubItemId = element.dataset.productVariantId;
    const uniqueId = getUniqueId();

    // Clear and set main product and unique ID inputs
    const mainProductInput = document.querySelector(`[name="properties[mainProduct]"]`);
    const uniqueIdInput = document.querySelector(`[name="properties[uniqueId]"]`);
    
    if (mainProductInput) {
        mainProductInput.value = "";
        mainProductInput.value = mainProductId;
    }

    if (uniqueIdInput) {
        uniqueIdInput.value = "";
        uniqueIdInput.value = uniqueId;
    }

    // Initialize bundle body structure
    let bundleBody = {
        items: [],
        sections: ["cart-drawer", "cart-icon-bubble"],
        section_url: `${window.location.pathname}`,
    };

    // Process bundle based on form data
    if (formData) {
        const formName = formData.formName;

        // Function to get personalize type based on form name and icon
        const getPersonalizeType = () => {
            switch(formName) {
                case 'Name':
                    return JSON.parse(element.dataset.personalizeName);
                case 'Icon':
                    // For Icon, distinguish between predefined and custom icon
                    return formData.icon 
                        ? JSON.parse(element.dataset.personalizeIcon)
                        : JSON.parse(element.dataset.personalizeCustomIcon);
                case 'Name and Icon':
                    // For combined Name and Icon, similar logic
                    return formData.icon 
                        ? JSON.parse(element.dataset.personalizeNameIcon)
                        : JSON.parse(element.dataset.personalizeCustomNameIcon);
                default:
                    return null;
            }
        };

        const personalizeType = getPersonalizeType();

        if (personalizeType) {
            personalizeType.variants.forEach((variant) => {
                const itemProperties = {
                    mainProductId: mainProductId,
                    uniqueSubId: uniqueId
                };

                // Add additional properties based on form name
                if (formName === 'Name') {
                    itemProperties.productType = true;
                }

                if (formName === 'Icon') {
                    const customIconInput = document.querySelector('#property-custom-icon');
                    if (customIconInput) {
                        itemProperties.customIcon = customIconInput.value;
                    }
                }

                if (formName === 'Name and Icon') {
                    itemProperties.productType = true;
                }

                bundleBody.items.push({
                    id: JSON.stringify(variant.id),
                    quantity: 1,
                    properties: itemProperties
                });
            });
        }
    } else {
        // If no personalization data, submit only the main product
        bundleBody.items.push({
            id: mainSubItemId,
            quantity: 1,
            properties: {
                mainProduct: mainProductId,
            },
        });
    }

    // Store bundle body in both localStorage and cookie
    try {
        // Store in localStorage for custom icon support
        localStorage.setItem('bundleBody', JSON.stringify(bundleBody));
        
        // Store in cookie for broader compatibility
        setCookie('bundleBody', bundleBody);
    } catch (error) {
        console.error('Error storing bundle body:', error);
    }

    return bundleBody;
}

// Utility function to generate unique ID (if not already defined)
function getUniqueId() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    const milliseconds = String(now.getMilliseconds()).padStart(3, '0');
    
    return `${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
}

// Ensure the function is globally available
if (typeof window !== 'undefined') {
    window.bundlePersonalization = bundlePersonalization;
}

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

document.addEventListener('DOMContentLoaded', () => {

    if(localStorage.getItem('formData')) {
        localStorage.removeItem('formData');
        checkLocalStorage();
    }
    if(localStorage.getItem('bundleBody')) {
        localStorage.removeItem('bundleBody');
        checkLocalStorage();
    }

    getProductSKU();

});

function getProductSKU(){
    /* SKU Schema for Selected Product Variants */ 

    const productName = document.querySelector('.product__title').innerText.trim();
    console.log(productName);
    
    let topSize = '';
    let bottomSize = '';

    const productCodeMap = {
        'Scrub Set': 'SS',
        'Scrubs': 'SS',
        'Scrub': 'SS',
        'Lab Coat': 'LC'
    };

    const genderMap = { 'Men': 'M', 'Women': 'W' };

    const styleMap = { 
    'Technical': 'T', 'Util Tech': 'UT', 'Eco Tech 11': 'E11', 'Elite Pro': 'EP' ,'Eco Tech 5': 'E5'
    };
    const colorMap = {
        'Black': 'BLK', 'Burgundy': 'BUR', 'Forest Green': 'FGN', 'Caribbean Blue': 'CBU', 
        'Royal Navy': 'RNY', 'Midnight Black': 'MBL', 'Midnight Green': 'MGN', 'Midnight Blue': 'MBU', 
        'Lavender': 'LAV', 'Terra Pink': 'TPK', 'Slate Grey': 'SGY', 'Ceil Blue': 'CLU', 
        'Electric Blue': 'EBU', 'Plum': 'PLM','Galaxy':'GXY','Hunter Green':'HTR','Espresso':'ESP','Midnight Teal':'TEL'
    };

    document.querySelectorAll('.active--varaint').forEach(variant => {
        if(variant.dataset.option.includes('top')) {
            topSize = variant.innerText.trim();
        }
        else if(variant.dataset.option.includes('bottom')){
            bottomSize = variant.innerText.trim();
        }
    });

    // Determine product code (SS or LC) based on presence of "Scrub Set" or "Lab Coat"
    let productCode = '';
    for (let key in productCodeMap) {
        if (productName.includes(key)) {
            productCode = productCodeMap[key];
            break;
        }
    }

    // Extract gender
    let gender = '';
    for (let key in genderMap) {
        if (productName.includes(key)) {
            gender = genderMap[key];
            break;
        }
    }

    // Extract color (handle multi-word color names)
    let color = '';
    for (let key in colorMap) {
        if (productName.includes(key)) {
            color = colorMap[key];
            break;
        }
    }

    // Extract style (handle multi-word style names)
    let style = '';
    for (let key in styleMap) {
        if (productName.includes(key)) {
            style = styleMap[key];
            break;
        }
    }

    // Build SKU with non-blank values only
    const skuParts = [productCode, gender, style, color, topSize, bottomSize];
    const sku = skuParts.filter(part => part).join('-'); // Skip any blank parts

    console.log('SKU:', sku);

    const skuInput = document.querySelector('input[name="properties[SKU]"]');
    if (skuInput) {
        if(skuInput.value !== ''){
            skuInput.value = sku;
        }
        else{
            skuInput.value = "";
            skuInput.value = sku;
        }
        
    }
}





// This code should replace the event listener at the end of your paste-2.txt file
// that begins with: document.addEventListener("DOMContentLoaded", () => {
document.addEventListener("DOMContentLoaded", () => {
    // Check for color change via URL parameters - clear personalization if found
    const urlParams = new URLSearchParams(window.location.search);
    const hasColorParam = urlParams.has('variant') || urlParams.has('color');
    
    if (hasColorParam) {
        // If URL contains variant or color params, clear all personalization data
        removeCookie('formData');
        removeCookie('color-name');
        removeCookie('bundleBody');
        localStorage.removeItem('formData');
        localStorage.removeItem('bundleBody');
    }

    // Ensure event listeners are only attached once
    if (!window.uploadEventListenersAttached) {
        // First, make sure the file input exists in the DOM
        let fileInput = document.getElementById('property-custom-icon');
        
        // If it doesn't exist, create it
        if (!fileInput) {
            fileInput = document.createElement('input');
            fileInput.type = 'file';
            fileInput.id = 'property-custom-icon';
            fileInput.accept = 'image/*';
            fileInput.classList.add('tw-w-[0.1rem]', 'tw-h-[0.1rem]', 'tw-invisible');
            document.body.appendChild(fileInput);
        }
        
        // Select the custom icon elements
        const secondaryCustomIcon = document.querySelector('#secondary-property-custom-icon');
        const tertiaryCustomIcon = document.querySelector('#tertiary-property-custom-icon');

        // Safely attach event listeners with checks
       // Attach event listeners for secondary custom icon
if (secondaryCustomIcon) {
    secondaryCustomIcon.addEventListener('click', (e) => {
        e.preventDefault();
        
        // Reset styles for all icon labels in the icon-picker
        const iconLabels = document.querySelectorAll('icon-picker label');
        if (iconLabels) {
            iconLabels.forEach(label => {
                if (label) {
                    label.style.border = '0';
                    label.style.padding = '0';
                    label.style.width = '3.6rem';
                    label.style.height = '3.6rem';
                    label.style.outline = 'none';
                }
            });
        }

        // Uncheck all icon radio buttons in secondary form
        const iconInputs = document.querySelectorAll('.icon-input');
        if (iconInputs) {
            iconInputs.forEach(input => {
                if (input) input.checked = false;
            });
        }

        // Clear selected icon text
        const selectedIconSpan = document.getElementById('selected-icon');
        if (selectedIconSpan) {
            selectedIconSpan.textContent = '';
        }

        fileInput.accept = "image/*";
        fileInput.setAttribute('data-active-form', 'secondary');
        
        if (fileInput) {
            fileInput.click();
        }
    });
}

        // Attach event listeners for tertiary custom icon
       if (tertiaryCustomIcon) {
    tertiaryCustomIcon.addEventListener('click', (e) => {
        e.preventDefault();
        
        // Reset styles for all icon labels in the tertiary-icon-picker
        const tertiaryIconLabels = document.querySelectorAll('tertiary-icon-picker label');
        if (tertiaryIconLabels) {
            tertiaryIconLabels.forEach(label => {
                if (label) {
                    label.style.border = '0';
                    label.style.padding = '0';
                    label.style.width = '3.6rem';
                    label.style.height = '3.6rem';
                    label.style.outline = 'none';
                }
            });
        }

        // Uncheck all icon radio buttons in tertiary form
        const tertiaryIconInputs = document.querySelectorAll('.tertiary-icon-input');
        if (tertiaryIconInputs) {
            tertiaryIconInputs.forEach(input => {
                if (input) input.checked = false;
            });
        }

        // Clear selected icon text
        const selectedIconSpan = document.querySelector('tertiary-icon-picker #selected-icon');
        if (selectedIconSpan) {
            selectedIconSpan.textContent = '';
        }

        fileInput.setAttribute('data-active-form', 'tertiary');
        
        if (fileInput) {
            fileInput.click();
        }
    });
}

        // Common file input change handler with safety checks
     // Common file input change handler with safety checks
if (fileInput) {
    // Remove any existing event listeners first to avoid duplicates
    const oldChangeHandler = fileInput._changeHandler;
    if (oldChangeHandler) {
        try {
            fileInput.removeEventListener('change', oldChangeHandler);
        } catch (e) {
            console.error("Error removing old event listener:", e);
        }
    }
    
    // Add new change handler and store reference for future cleanup
    // Complete file input change handler with fallback to first icon and enhanced validation
const newChangeHandler = (e) => {
    const activeForm = fileInput.getAttribute('data-active-form');
    
    // If file selection was cancelled or no file selected
    if (!e.target.files || e.target.files.length === 0) {
        // Reset file input
        fileInput.value = '';
        
        // Reselect the first icon as default fallback
        if (activeForm === 'secondary') {
            const firstIcon = document.getElementById('icon-1');
            if (firstIcon) {
                firstIcon.checked = true;
                // Trigger the change event to update UI properly
                const changeEvent = new Event('change', { bubbles: true });
                firstIcon.dispatchEvent(changeEvent);
                
                // Update selected icon display
                const selectedIconSpan = document.getElementById('selected-icon');
                if (selectedIconSpan) {
                    selectedIconSpan.textContent = firstIcon.value;
                }
                
                // Update price back to regular icon price
                updatePrice({ target: { type: 'radio' } }, 'secondary');
            }
        } else if (activeForm === 'tertiary') {
            const firstIcon = document.getElementById('tertiary-icon-1');
            if (firstIcon) {
                firstIcon.checked = true;
                // Trigger the change event to update UI properly
                const changeEvent = new Event('change', { bubbles: true });
                firstIcon.dispatchEvent(changeEvent);
                
                // Update selected icon display
                const selectedIconSpan = document.querySelector('tertiary-icon-picker #selected-icon');
                if (selectedIconSpan) {
                    selectedIconSpan.textContent = firstIcon.value;
                }
                
                // Update price back to regular icon price
                updatePrice({ target: { type: 'radio' } }, 'tertiary');
            }
        }
        
        // Reset upload UI elements to default state
        let uploadLabel, fileDisclaimer, labelAbbr;
        if (activeForm === 'secondary') {
            uploadLabel = document.getElementById('upload-label');
            fileDisclaimer = document.getElementById('file-disclaimer');
            labelAbbr = document.getElementById('label-abbr');
        } else if (activeForm === 'tertiary') {
            const tertiaryForm = document.querySelector('tertiary-form');
            if (tertiaryForm) {
                uploadLabel = tertiaryForm.querySelector('#upload-label');
                fileDisclaimer = tertiaryForm.querySelector('#file-disclaimer');
                labelAbbr = tertiaryForm.querySelector('#label-abbr');
            }
        }
        
        if (uploadLabel && fileDisclaimer && labelAbbr) {
            const originalLabelValue = uploadLabel.dataset.labelValue;
            uploadLabel.textContent = originalLabelValue;
            labelAbbr.title = '';
            fileDisclaimer.textContent = 'Only Accepting files lesser than 10MB';
            fileDisclaimer.style.fontWeight = 'normal';
            fileDisclaimer.style.color = ''; // Reset any error color
        }
        
        return;
    }
    
    // Validate the selected file
    if (!validateFileInput(fileInput)) {
        // Reset the file input
        fileInput.value = '';
        
        // Reselect first icon as fallback when file is invalid
        if (activeForm === 'secondary') {
            const firstIcon = document.getElementById('icon-1');
            if (firstIcon) {
                firstIcon.checked = true;
                const changeEvent = new Event('change', { bubbles: true });
                firstIcon.dispatchEvent(changeEvent);
                
                const selectedIconSpan = document.getElementById('selected-icon');
                if (selectedIconSpan) {
                    selectedIconSpan.textContent = firstIcon.value;
                }
                
                updatePrice({ target: { type: 'radio' } }, 'secondary');
            }
        } else if (activeForm === 'tertiary') {
            const firstIcon = document.getElementById('tertiary-icon-1');
            if (firstIcon) {
                firstIcon.checked = true;
                const changeEvent = new Event('change', { bubbles: true });
                firstIcon.dispatchEvent(changeEvent);
                
                const selectedIconSpan = document.querySelector('tertiary-icon-picker #selected-icon');
                if (selectedIconSpan) {
                    selectedIconSpan.textContent = firstIcon.value;
                }
                
                updatePrice({ target: { type: 'radio' } }, 'tertiary');
            }
        }
        
        // Show error message for invalid file
        let uploadLabel, fileDisclaimer, labelAbbr;
        if (activeForm === 'secondary') {
            uploadLabel = document.getElementById('upload-label');
            fileDisclaimer = document.getElementById('file-disclaimer');
            labelAbbr = document.getElementById('label-abbr');
        } else if (activeForm === 'tertiary') {
            const tertiaryForm = document.querySelector('tertiary-form');
            if (tertiaryForm) {
                uploadLabel = tertiaryForm.querySelector('#upload-label');
                fileDisclaimer = tertiaryForm.querySelector('#file-disclaimer');
                labelAbbr = tertiaryForm.querySelector('#label-abbr');
            }
        }
        
        if (fileDisclaimer) {
            fileDisclaimer.textContent = 'Invalid file. Please upload an image file under 10MB.';
            fileDisclaimer.style.color = '#ff0000';
            fileDisclaimer.style.fontWeight = 'bold';
        }
        
        if (uploadLabel && labelAbbr) {
            const originalLabelValue = uploadLabel.dataset.labelValue;
            uploadLabel.textContent = originalLabelValue;
            labelAbbr.title = '';
        }
        
        // Show file validation error briefly, then reset
        setTimeout(() => {
            if (fileDisclaimer) {
                fileDisclaimer.textContent = 'Only Accepting files lesser than 10MB';
                fileDisclaimer.style.color = '';
                fileDisclaimer.style.fontWeight = 'normal';
            }
        }, 3000); // Reset error message after 3 seconds
        
        return;
    }
    
    // Valid file selected - process it
    const file = e.target.files[0];
    
    if (file) {
        const fileName = file.name;
        let uploadLabel, fileDisclaimer, labelAbbr;
        
        try {
            // Hide any existing icon error messages when valid file is selected
            const iconError = activeForm === 'secondary' 
                ? document.querySelector("#secondary-icon-error")
                : document.querySelector("#tertiary-icon-error");
            if (iconError) {
                iconError.classList.add('tw-hidden');
            }
            
            // Update UI elements based on which form is active
            if (activeForm === 'secondary') {
                // Update price to custom icon price
                updatePrice(e, 'secondary');
                
                // Get UI elements
                uploadLabel = document.getElementById('upload-label');
                fileDisclaimer = document.getElementById('file-disclaimer');
                labelAbbr = document.getElementById('label-abbr');
                
                // Clear form data for icon switching
                const formData = JSON.parse(localStorage.getItem('formData') || '{}');
                if (formData) {
                    formData.icon = ''; // Clear any selected predefined icon
                    localStorage.setItem('formData', JSON.stringify(formData));
                }
                
                // Clear selected icon display since we're using custom
                const selectedIconSpan = document.getElementById('selected-icon');
                if (selectedIconSpan) {
                    selectedIconSpan.textContent = 'Custom Icon';
                }
                
            } else if (activeForm === 'tertiary') {
                // Update price to custom icon price
                updatePrice(e, 'tertiary');
                
                // Get UI elements from tertiary form
                const tertiaryForm = document.querySelector('tertiary-form');
                if (tertiaryForm) {
                    uploadLabel = tertiaryForm.querySelector('#upload-label');
                    fileDisclaimer = tertiaryForm.querySelector('#file-disclaimer');
                    labelAbbr = tertiaryForm.querySelector('#label-abbr');
                }
                
                // Clear form data for icon switching
                const formData = JSON.parse(localStorage.getItem('formData') || '{}');
                if (formData) {
                    formData.icon = ''; // Clear any selected predefined icon
                    localStorage.setItem('formData', JSON.stringify(formData));
                }
                
                // Clear selected icon display since we're using custom
                const selectedIconSpan = document.querySelector('tertiary-icon-picker #selected-icon');
                if (selectedIconSpan) {
                    selectedIconSpan.textContent = 'Custom Icon';
                }
            }
            
            // Update upload UI elements
            if (uploadLabel && fileDisclaimer && labelAbbr) {
                uploadLabel.textContent = fileName;
                labelAbbr.title = fileName;
                fileDisclaimer.textContent = 'File Uploaded Successfully';
                fileDisclaimer.style.fontWeight = 'bold';
                fileDisclaimer.style.color = '#008000'; // Green color for success
            }
            
            // Optional: Add file size info
            if (fileDisclaimer && file.size) {
                const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2);
                setTimeout(() => {
                    if (fileDisclaimer) {
                        fileDisclaimer.textContent = `File Uploaded Successfully (${fileSizeMB}MB)`;
                    }
                }, 500);
            }
            
        } catch (error) {
            console.error("Error handling file change:", error);
            
            // Show error message
            if (fileDisclaimer) {
                fileDisclaimer.textContent = 'Error processing file. Please try again.';
                fileDisclaimer.style.color = '#ff0000';
                fileDisclaimer.style.fontWeight = 'bold';
            }
            
            // Reset file input on error
            fileInput.value = '';
            
            // Fallback to first icon
            if (activeForm === 'secondary') {
                const firstIcon = document.getElementById('icon-1');
                if (firstIcon) {
                    firstIcon.checked = true;
                    firstIcon.dispatchEvent(new Event('change', { bubbles: true }));
                }
            } else if (activeForm === 'tertiary') {
                const firstIcon = document.getElementById('tertiary-icon-1');
                if (firstIcon) {
                    firstIcon.checked = true;
                    firstIcon.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }
        }
    }
};

// Apply the handler to the file input
if (fileInput) {
    // Remove any existing event listeners first to avoid duplicates
    const oldChangeHandler = fileInput._changeHandler;
    if (oldChangeHandler) {
        try {
            fileInput.removeEventListener('change', oldChangeHandler);
        } catch (e) {
            console.warn("Could not remove old event listener:", e);
        }
    }
    
    // Store reference and add new handler
    fileInput._changeHandler = newChangeHandler;
    fileInput.addEventListener('change', newChangeHandler);
}
    
    fileInput._changeHandler = newChangeHandler;
    fileInput.addEventListener('change', newChangeHandler);
}

        // Mark event listeners as attached
        window.uploadEventListenersAttached = true;
    }

    // Keep the existing functionality
    if (!getCookie('formData') && !localStorage.getItem('formData')) {
        removeCookie('bundleBody');
        localStorage.removeItem('bundleBody');
    }

    const tabs = document.querySelectorAll("[id^=tab-]");
    const forms = {
        "tab-name": document.getElementById("form-primary"),
        "tab-icon": document.getElementById("form-secondary"),
        "tab-both": document.getElementById("form-tertiary"),
    };

    // Show the first form by default and highlight its tab
    if (forms["tab-name"]) {
        forms["tab-name"].classList.remove("tw-hidden");
        const tabName = document.getElementById("tab-name");
        if (tabName) {
            tabName.classList.remove("color_E6E6E6");
            tabName.classList.add("color_C8C8CA");
        }
    }

    if (tabs && tabs.length > 0) {
        tabs.forEach((tab) => {
            if (tab) {
                tab.addEventListener("click", (e) => {
                    Object.values(forms).forEach(form => {
                        if (form) form.classList.add("tw-hidden");
                    });

                    const currentForm = forms[tab.id];
                    if (currentForm) {
                        currentForm.classList.remove("tw-hidden");
                        currentForm.classList.add("tw-transition-opacity", "tw-duration-300", "tw-opacity-0");
                        currentForm.offsetHeight; // Trigger reflow
                        currentForm.classList.remove("tw-opacity-0");
                        currentForm.classList.add("tw-opacity-100");

                        if (currentForm.id === 'form-secondary') {
                            const rangePrice = document.getElementById('secondary-form-price');
                            if (rangePrice) rangePrice.textContent = rangePrice.dataset.formPrice;
                        }

                        if (currentForm.id === 'form-tertiary') {
                            const rangePrice = document.getElementById('tertiary-form-price');
                            if (rangePrice) rangePrice.textContent = rangePrice.dataset.formPrice;
                        }
                    }

                    tabs.forEach(tab => {
                        if (tab) {
                            tab.classList.remove("color_C8C8CA");
                            tab.classList.add("color_E6E6E6");
                        }
                    });

                    // Add the active class to the clicked tab
                    tab.classList.add("color_C8C8CA");
                    tab.classList.remove("color_E6E6E6");
                });
            }
        });
    }

    const primaryName = document.querySelector('.primary_name');
    const tertiaryName = document.querySelector('.tertiary_name');

    if (primaryName) {
        primaryName.addEventListener('blur', () => {
            const errorMessage = document.querySelector('#primary-error-message');
            if (primaryName.value == '') {
                if (errorMessage) errorMessage.classList.remove('tw-hidden');
            } else {
                if (errorMessage) errorMessage.classList.add('tw-hidden');
            }
        });
    }

    if (tertiaryName) {
        tertiaryName.addEventListener('blur', () => {
            const errorMessage = document.querySelector('#tertiary-error-message');
            if (tertiaryName.value == '') {
                if (errorMessage) errorMessage.classList.remove('tw-hidden');
            } else {
                if (errorMessage) errorMessage.classList.add('tw-hidden');
            }
        });
    }

    // Function to handle color swatch clicks that should reset personalization
    function initializeColorSwatches() {
        // Handle both core and limited color swatches
        const coreColorInputs = document.querySelectorAll('#core-color-swatches input[type="radio"]');
        const limitedColorInputs = document.querySelectorAll('#limited-color-swatches input[type="radio"]');
        
        // Function to update preview background color
        function updatePreviewBackgroundColor(colorCode) {
            // Target all preview backgrounds
            const previewBackgrounds = [
                document.getElementById('preview-primary-background'),
                document.querySelector('.tertiary_form_preview #preview-primary-background'),
                document.getElementById('icon-holder'),
                document.querySelector('.tertiary_form_preview #icon-holder')
            ];
            
            // Update background color for all preview elements
            previewBackgrounds.forEach(element => {
                if (element) {
                    element.style.backgroundColor = colorCode;
                }
            });
            
            // Store the color in localStorage and cookie for persistence
            try {
                localStorage.setItem('selected-preview-color', colorCode);
                setCookie('selected-preview-color', colorCode);
            } catch (e) {
                console.error("Error storing color:", e);
            }
        }
        
        // Add event listeners to core color swatches
        if (coreColorInputs && coreColorInputs.length > 0) {
            coreColorInputs.forEach(input => {
                if (input) {
                    input.addEventListener('change', () => {
                        if (input.checked) {
                            // Check if we have personalization data stored
                            const hasPersonalization = getCookie('formData') || localStorage.getItem('formData');
                            
                            if (hasPersonalization) {
                                // Clear personalization data from both cookies and localStorage
                                removeCookie('formData');
                                removeCookie('color-name');
                                removeCookie('bundleBody');
                                localStorage.removeItem('formData');
                                localStorage.removeItem('bundleBody');
                                
                                // Update UI to reflect the cleared personalization
                                checkLocalStorage();
                                removeAllInputs();
                            }
                            
                            const colorCode = input.getAttribute('data-bg-color-preview');
                            if (colorCode) {
                                updatePreviewBackgroundColor(colorCode);
                            }
                        }
                    });
                    
                    // Apply initial color if checked
                    if (input.checked || input.classList.contains('checked__color')) {
                        const colorCode = input.getAttribute('data-bg-color-preview');
                        if (colorCode) {
                            updatePreviewBackgroundColor(colorCode);
                        }
                    }
                }
            });
        }
        
        // Add event listeners to limited color swatches
        if (limitedColorInputs && limitedColorInputs.length > 0) {
            limitedColorInputs.forEach(input => {
                if (input) {
                    input.addEventListener('change', () => {
                        if (input.checked) {
                            // Check if we have personalization data stored
                            const hasPersonalization = getCookie('formData') || localStorage.getItem('formData');
                            
                            if (hasPersonalization) {
                                // Clear personalization data from both cookies and localStorage
                                removeCookie('formData');
                                removeCookie('color-name');
                                removeCookie('bundleBody');
                                localStorage.removeItem('formData');
                                localStorage.removeItem('bundleBody');
                                
                                // Update UI to reflect the cleared personalization
                                checkLocalStorage();
                                removeAllInputs();
                            }
                            
                            const colorCode = input.getAttribute('data-bg-color-preview');
                            if (colorCode) {
                                updatePreviewBackgroundColor(colorCode);
                            }
                        }
                    });
                    
                    // Apply initial color if checked
                    if (input.checked || input.classList.contains('checked__color')) {
                        const colorCode = input.getAttribute('data-bg-color-preview');
                        if (colorCode) {
                            updatePreviewBackgroundColor(colorCode);
                        }
                    }
                }
            });
        }
    }
    
    // Fix for product-form.js error
    // Add safety patch for event listeners
    function patchEventListeners() {
        setTimeout(() => {
            const fileInputs = document.querySelectorAll('input[type="file"]');
            fileInputs.forEach(input => {
                if (input && !input._safetyPatched) {
                    // Create backup of original methods
                    const originalAddEventListener = input.addEventListener;
                    const originalRemoveEventListener = input.removeEventListener;
                    
                    // Override addEventListener to keep track of listeners
                    input.addEventListener = function(type, listener, options) {
                        this._listeners = this._listeners || {};
                        this._listeners[type] = this._listeners[type] || [];
                        this._listeners[type].push(listener);
                        return originalAddEventListener.call(this, type, listener, options);
                    };
                    
                    // Override removeEventListener with safety checks
                    input.removeEventListener = function(type, listener, options) {
                        if (!this._listeners || !this._listeners[type]) {
                            return; // Safely do nothing if no listeners exist
                        }
                        const index = this._listeners[type].indexOf(listener);
                        if (index !== -1) {
                            this._listeners[type].splice(index, 1);
                        }
                        try {
                            return originalRemoveEventListener.call(this, type, listener, options);
                        } catch (e) {
                            console.warn("Safe ignore: removeEventListener error prevented", e);
                        }
                    };
                    
                    input._safetyPatched = true;
                }
            });
        }, 500); // Small delay to ensure all scripts have loaded
    }
    
    // Run the safety patch
    patchEventListeners();
    
    // Initialize color swatches
    initializeColorSwatches();
    
    // Run the checkLocalStorage function
    checkLocalStorage();
    
    // Initialize the product form
    const formElement = document.querySelector('[data-product-form]');
    if (formElement) {
        submitFormToLineProperties(formElement);
        
        // Check both cookie and localStorage for bundle data
        const bundleData = getCookie('bundleBody') || localStorage.getItem('bundleBody');
        if (bundleData) {
            bundlePersonalization(formElement);
        }
    }
    
    // Get product SKU
    getProductSKU();
});